import { t } from "ttag";

import { Alert, Heading } from "@/shared/ui";

export const PasswordTips = () => {
  return (
    <Alert withIcon={false} variant="outlined">
      <Heading size="xx-small" level={3} color="primary">
        {t`Password Tips`}:
      </Heading>

      <ul className="list-inside list-disc pl-2">
        <li>{t`Include at least 8 characters.`}</li>
        <li>{t`Incorporate numbers (0-9).`}</li>
        <li>{t`Utilize special characters (e.g., !, @, #, $, %, etc).`}</li>
        <li>
          {t`Avoid common phrases like "password," "123456," or "qwerty."`}
        </li>
        <li>{t`Include a mix of uppercase and lowercase letters.`}</li>
      </ul>
    </Alert>
  );
};
